import React from 'react';
import '../styles/LoginPage.css';

interface Props {
  onLogin: () => void;
}

const LoginPage: React.FC<Props> = ({ onLogin }) => {
  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <span className="logo-icon">⚡</span>
          <h1>EA Spec Driven</h1>
        </div>

        <p className="login-subtitle">
          Define a specification — get a deployed application.
        </p>

        <div className="login-features">
          <div className="feature">
            <span className="feature-icon">📝</span>
            <div>
              <h3>Define Requirements</h3>
              <p>MoSCoW-prioritized requirements steer the AI</p>
            </div>
          </div>
          <div className="feature">
            <span className="feature-icon">🎯</span>
            <div>
              <h3>Select Skills</h3>
              <p>Built-in capabilities plus the skills.sh catalog</p>
            </div>
          </div>
          <div className="feature">
            <span className="feature-icon">🤖</span>
            <div>
              <h3>AI Code Generation</h3>
              <p>Claude Code SDK generates a working React app</p>
            </div>
          </div>
          <div className="feature">
            <span className="feature-icon">🚀</span>
            <div>
              <h3>Auto Deploy</h3>
              <p>S3, CloudFront, Cognito, DNS, docs & videos — automated</p>
            </div>
          </div>
        </div>

        <button className="login-btn" onClick={onLogin}>
          Sign in with Cognito
        </button>

        <p className="login-help">
          Use your EA Portal credentials to sign in
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
